<script>
    // import DeviceDetector from "svelte-device-detector";
    import device from "current-device";
    import {user} from "./sessionStore"
    import { get } from 'svelte/store';
    import {supabase} from "./supabaseClient"
    import Auth from "./Auth.svelte"
    import Profile from "./Profile.svelte"

    import router from 'page'
    import LandingPage from "./LandingPage.svelte"
    import MyBoards from "./MyBoards.svelte"
    import Board from "./Board.svelte"
    import MobileSelectAttendee from "./MobileSelectAttendee.svelte"
    import MobileBoard from "./MobileBoard.svelte"
    import Redirect from "./Redirect.svelte"
    import Login from "./Login.svelte"
    import ResetPassword from "./ResetPassword.svelte"
    import RequestPasswordReset from "./RequestPasswordReset.svelte"
    import SignUp from "./SignUp.svelte"
    import TOC from "./TOC.svelte"
    import CreateTrialBoard from "./CreateTrialBoard.svelte"
    import Beta from "./Beta.svelte"
    import BoardNotFound from "./BoardNotFound.svelte"
    import RequestEmailSignIn from "./RequestEmailSignIn.svelte"
    import LoginConfirmation from "./LoginConfirmation.svelte"
    import EmailSigninRedirect from "./EmailSigninRedirect.svelte"
   

    supabase.auth.onAuthStateChange((_, session) => {
      console.log('OnAuthStateChange:Event='+_)
        if (session) {
          user.set(session.user)
          checkUserPlan();
          // if (window.location.pathname !== '/myboards/' && window.location.pathname !== '/ResetPassword') {
          //   router.redirect('/myboards/');
          // }
        }
        else {
          user.set(null)
        }
    })

  const checkUserPlan = async () => {
    const { data, error } = await supabase
      .from('user_memberships')
       .select(`accounts (id, plans (plan_name, plan_id, features, max_boards))`)
      if(error) {
        console.log(error)
      } else {
       if (data[0]){
        user.plan = user.plan=data[0].accounts.plans
        }
      }

  }


  let page
  let params

  // Redirect / to My Boards if user is logged in otherwise disaply landing page
  router ('/', () =>{
      // If app.moodfirst redirect to My Boards
      if (window.location.host.includes('app.')){
        // If user logged in go to My boards other wise login
        if (supabase.auth.currentUser) {
            page = MyBoards
        } else {
          router.redirect('/login')
        }
      } else {
        page = LandingPage
      }
  })

  router('/login', () => {
      if (!$user) {
        page = Login
      } else {
          router.redirect('/myboards/')
      }
  })

  // Redirect user to landing page if not logged in
  router('/myboards/', () => {
    const currentUser = get(user)
    if (!currentUser) {
      router.redirect('/login')
  }
    page = MyBoards
  })

  router('/board', () => {
    new URLSearchParams(window.location.search).get('email')
    if (device.mobile()){
      if($user) {
        page = Board
      } else if (new URLSearchParams(window.location.search).get('trialBoard')) {
        page = Board
      } else {
        page = MobileBoard
      }
    } else {
      page = Board
    }
  })

  router('/viewBoard', () => (page = Redirect))
  // router('/login', () => (page = Login))
  router('/ResetPassword', () => (page = ResetPassword))
  router('/RequestPasswordReset', () => (page = RequestPasswordReset))
  router('/Signup', () => (page = SignUp))
  // Landing page
  router('/ToC', () => (page = TOC))
  router('/*&type=recovery*', () => (page = ResetPassword))
  router('/MobileBoard', () => (page = MobileBoard))
  router('/CreateTrialBoard', () => (page = CreateTrialBoard))
  router('/Beta', () => (page = Beta))
  router('/boardNotFound', () => (page = BoardNotFound))
  router('/LoginConfirmation', () => (page = LoginConfirmation))
  router('/RequestEmailSignIn', () => (page = RequestEmailSignIn))
  router('/EmailSigninRedirect', () => (page = EmailSigninRedirect))
  // router.start()
  const initializeAuthAndStart = async () => {
  const { data } = await supabase.auth.getSession();

  if (data?.session?.user) {
    user.set(data.session.user);
    await checkUserPlan();
  }

    router.start(); // now it's safe to start routing
  };

  initializeAuthAndStart();

</script>

<svelte:component this="{page}" params="{params}" router="{router}"/>

<style>
:global(body) {background-color: white !important;}

:root {
  --blue: #255991;
  --green: #8AE3C7;
  --aqua: #34C7C8;

  --aqua-40: #34c7c866;
  --green-50: #8ae3c780;

  --dark-grey: #6e6e6e;
}

:global(button.primary) {background-color: var(--aqua) !important; color: white !important; font-weight: bold !important}
:global(button.secondary) {background-color: grey !important; color: white !important; font-weight: bold !important}


/* New Feature styles */
  @keyframes -global-pulse {
    0%, 100% {
      transform: translateY(-50%) scale(1);
    }
    50% {
      transform: translateY(-50%) scale(1.1);
    }
  }



   :global(.new-feature) {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  :global(.new-feature)::after {
    content: "New";
    position: absolute;
    bottom: 25px;
    right: -28px;
    background-color: #8AE3C7;
    color: black;
    font-size: 16px;
    font-weight: bold;
    padding: 2px 5px;
    border-radius: 2px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    animation: pulse 1.8s infinite;
  }


</style>
